// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  parasutTestTaxNumber: '7171717171',
  appVersion: 'v8.2.4',
  USERDATA_KEY: 'authf649fc9a5f55',
  apiUrl: '/identity/api/v1',
  workListApiUrl: '/worklist/api/v1',
  aiApiUrl: '/ai/api/v1',
  communicationApiUrl: '/communication/api/v1',
  communicationHubUrl: '/communication',
  vehicleApiUrl: '/vehicle/api/v1',
  minioUrl: '/minio/worklist-images',
  minioWorkOrderPhotoUrl: '/minio/worklist-program-images',
  appTitle: 'Otomoto - Dev',
  appThemeName: 'otomoto',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
